module.exports = __webpack_public_path__ + "e26b1f234833622d641559b107f8516a.svg";